import { render, staticRenderFns } from "./AdminWebinarVideo.vue?vue&type=template&id=e2fa3fce&scoped=true&"
import script from "./AdminWebinarVideo.vue?vue&type=script&lang=js&"
export * from "./AdminWebinarVideo.vue?vue&type=script&lang=js&"
import style0 from "./AdminWebinarVideo.vue?vue&type=style&index=0&id=e2fa3fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fa3fce",
  null
  
)

export default component.exports